import Device, { ParsedDbDevice } from "./Device";
import PhoneMeta from "./PhoneMeta";
import Subscription from "./Subscription";
import UserDevice from "./UserDevice";

interface User {
  id: string;
  uuid: string;
  email: string;
  firstname: string;
  lastname: string;
  isMetric: boolean;
  isVerified: boolean;
  isSubscribed: boolean;
  os: string;
  joinDate: string;
  updatedAt: string;
  devices?: UserDevice[];
  sharedDevices?: UserDevice[];
  phoneMeta?: PhoneMeta[];
  appConnections?: { appName: string; isEnabled: boolean }[];
  subscriptions?: Subscription[];
}

export const parseDbUser = (dbUser) => {
  let parsedUser: User = {
    //required
    id: dbUser.id ? dbUser.id : "",
    uuid: dbUser.uuid ? dbUser.uuid : "",
    email: dbUser.email ? dbUser.email : "",
    firstname: dbUser.firstname ? dbUser.firstname : "",
    lastname: dbUser.lastname ? dbUser.lastname : "",
    os: dbUser.os ? dbUser.os : "",
    isMetric: dbUser.is_metric && dbUser.is_metric === 1 ? true : false,
    isVerified: dbUser.is_verified && dbUser.is_verified === 1 ? true : false,
    isSubscribed:
      dbUser.is_subscribed && dbUser.is_subscribed === 1 ? true : false,
    joinDate: dbUser.join_date ? dbUser.join_date : "",
    updatedAt: dbUser.updated_at ? dbUser.updated_at : "",
    //optional
    phoneMeta:
      dbUser.phoneMeta && Array.isArray(dbUser.phoneMeta)
        ? dbUser.phoneMeta
        : [],
    devices: dbUser.devices,
    sharedDevices: dbUser.sharedDevices
  };

  //appConnections
  if (dbUser.appConnections && Array.isArray(dbUser.appConnections)) {
    parsedUser.appConnections = dbUser.appConnections.map((app) => {
      return {
        appName: app.appName
          ? app.appName
          : app.app_name
          ? app.app_name
          : "Unknown",
        isEnabled: app.is_enabled === 1 ? true : false,
      };
    });
  }
  
  return parsedUser;
};

export default User;
